import hookSlider from './slider';
import bindModals from './modals';
import './main.scss';

// slider logic
hookSlider();
// modal events
bindModals();